import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  startTime: {
    description: 'Start Time',
    defaultMessage: 'Start Time',
    id: 'udtp3p',
  },
  closeTime: {
    description: 'Close Time',
    defaultMessage: 'Close Time',
    id: 'j1NxtX',
  },
  pickupDate: {
    description: 'Pickup Date',
    defaultMessage: 'Pickup Date',
    id: 'H4Qs25',
  },
  pickupWindowFrom: {
    description: 'Pickup Window',
    defaultMessage: 'Pickup Window',
    id: 'OSTS3C',
  },
  pickupWindowTo: {
    description: 'The last part of From-To',
    defaultMessage: 'To',
    id: 'xDyf1G',
  },
});
